// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-radio-button.lit.scss INSTEAD!
import { css } from 'lit-element';
export default css`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-radio-button-container-margin=0] - margin of the container(XL)
   */
  --sh-radio-button-container-margin: 0;
  /* 
   * @cssprop [--sh-radio-button-label-line-height=1.25rem] - line height of the label
   */
  --sh-radio-button-label-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-radio-button-label-padding=0.25rem] - left padding of the label
   */
  --sh-radio-button-label-padding: 0.25rem;
  /* 
   * @cssprop [--sh-radio-button-label-margin=0.375rem 0] - top and bottom margins of the label
   */
  --sh-radio-button-label-margin: 0.375rem 0;
  /* 
   * @cssprop [--sh-radio-button-width=2rem] - width of the radio-button
   */
  --sh-radio-button-width: 2rem;
  /* 
   * @cssprop [--sh-radio-button-height=2rem] - height of radio-button
   */
  --sh-radio-button-height: 2rem;
  /* 
   * @cssprop [--sh-radio-button-pseudo-width=1rem] - width of the pseudo radio-button
   */
  --sh-radio-button-pseudo-width: 1rem;
  /* 
   * @cssprop [--sh-radio-button-pseudo-height=1rem] - height of the pseudo radio-button
   */
  --sh-radio-button-pseudo-height: 1rem;
  /* 
   * @cssprop [--sh-radio-button-pseudo-margin=0.5rem] - margin of the pseudo radio-button
   */
  --sh-radio-button-pseudo-margin: 0.5rem;
  /* 
   * @cssprop [--sh-radio-button-pseudo-border-width=0.125rem] - border-width of the pseudo radio-button
   */
  --sh-radio-button-pseudo-border-width: 0.125rem;
  /* 
   * @cssprop [--sh-radio-button-pseudo-border-width-active=0.3125rem] - border-width of the pseudo radio-button when active
   */
  --sh-radio-button-pseudo-border-width-active: 0.3125rem;
}

:host {
  outline: none;
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
  font: var(--body-1);
  color: var(--text-primary);
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}

:host([disabled]) {
  pointer-events: none;
  color: var(--text-disabled) !important;
}

:host(:not([disabled])) * {
  cursor: pointer;
}

:host .radio-container {
  display: flex;
  align-items: center;
  height: fit-content;
  width: 100%;
  position: relative;
  margin: var(--sh-radio-button-container-margin);
}

:host .radioBtn {
  opacity: 0;
  position: absolute;
  margin: 0;
  width: var(--sh-radio-button-width);
  height: var(--sh-radio-button-height);
  align-self: flex-start;
}

:host .pseudo-radio {
  border-radius: 50%;
  border-width: var(--sh-radio-button-pseudo-border-width);
  border-style: solid;
  border-color: rgba(var(--ui-1), var(--opacity-4));
  transition: var(--transition-time) all ease-in-out;
  margin: var(--sh-radio-button-pseudo-margin);
  box-sizing: border-box;
  height: var(--sh-radio-button-pseudo-height);
  width: var(--sh-radio-button-pseudo-width);
  align-self: flex-start;
}

:host label {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-left: var(--sh-radio-button-label-padding);
  margin: var(--sh-radio-button-label-margin);
  flex: 1;
  font: var(--body-1);
  line-height: var(--sh-radio-button-label-line-height);
  text-overflow: ellipsis;
  overflow: hidden;
}

/* Component State Styles */
:host([active]) .pseudo-radio {
  background: transparent;
  height: var(--sh-radio-button-pseudo-height);
  width: var(--sh-radio-button-pseudo-width);
  border-width: var(--sh-radio-button-pseudo-border-width-active) !important;
  box-sizing: border-box;
  border-style: solid;
  transition: var(--transition-time) all ease-in-out;
  border-color: rgba(var(--ui-2), var(--opacity-1));
}

/* Neutral */
:host([neutral][active]:not([disabled])) .pseudo-radio {
  border-color: rgba(var(--ui-1), var(--opacity-3));
}

:host([disabled]) .pseudo-radio,
:host([neutral][disabled][active]) .pseudo-radio {
  border-color: rgba(var(--ui-1), var(--opacity-5));
}

:host([disabled][active]:not([neutral])) .pseudo-radio {
  border-color: rgba(var(--ui-2), var(--opacity-5));
}

/* hover */
:host(:hover:not(.no-hovermq)) .pseudo-radio {
  border-color: rgba(var(--ui-1), var(--opacity-3));
}

:host([active]:hover:not(.no-hovermq)) .pseudo-radio {
  border-color: rgba(var(--ui-3), var(--opacity-1));
}

:host([neutral][active]:hover:not(.no-hovermq)) .pseudo-radio {
  border-color: rgba(var(--ui-1), var(--opacity-2));
}

.focus {
  outline: var(--focus-outline);
}`;